import { lazyLoad } from 'utils/loadable';

export const BillingPage = lazyLoad(
  () => import('./index'),
  module => module.Billing,
);
